module.exports = __webpack_public_path__ + "img/26-02.19b1d4ba.png";